import React, { Component } from "react";
import _ from "lodash";
import Modal from "react-modal";
import Loader from "react-loader-advanced";
import { connect } from "react-redux";
import { withRouter } from "react-router"
import noop from "lodash/noop";
import FavoritesModal from "../Modals/FavoritesModal";
import WorkingHoursModal from "../Modals/WorkingHoursModal";
import MODAL_SETTINGS from "../../styles/modalSettings";
import loaderSettings from "../../styles/loaderSettings";
import sentry from "../../utils/sentry";
import { getUser } from "../../actions/userActions";

require("./Welcome.scss");

class Welcome extends Component {
  constructor (props) {
    super(props);

    this.state = {
      loading: false,
      isEditFavoritesOpen: false,
      isWorkingHoursOpen: false
    };

    _.bindAll(this, "beginIntro", "nextStepWorkingHours", "nextStepFavorites");
  }

  beginIntro() {
    if (process.env.NODE_ENV === "development") {
      console.debug("Welcome.beginIntro");
    }

    this.setState({ isWorkingHoursOpen: true, isEditFavoritesOpen: false });
  }

  nextStepWorkingHours() {
    if (process.env.NODE_ENV === "development") {
      console.debug("Welcome.nextStepWorkingHours");
    }

    this.setState({ isWorkingHoursOpen: false, isEditFavoritesOpen: true });
  }

  async nextStepFavorites() {
    if (process.env.NODE_ENV === "development") {
      console.debug("Welcome.nextStepFavorites");
    }

    this.setState({ isEditFavoritesOpen: false, loading: true });

    try {
      await this.props.api.saveUserPreferences({
        ...this.props.settings,
        firstTimeLogin: false
      });

      await this.props.updateUser();
      await this.props.setFirstTimeOff();

      this.setState({ loading: false });

      setTimeout(() => {
        this.props.router.replace({ pathname: "/input-time" });
      }, 10);
    } catch (err) {
      sentry.logException(err);
      this.setState({ loading: false, isEditFavoritesOpen: true });
      alert("Error\n\nAn unexpected error occurred, please try again.");
    }
  }

  render () {
    const showWelcome = !this.state.loading
      && !this.state.isEditFavoritesOpen
      && !this.state.isWorkingHoursOpen;

    let prompt = null;

    if (showWelcome) {
      prompt = (
        <div className="loginContent">
          <h1>Welcome to the<br />Time Tracker app</h1>
          <p>
            Since this is your first time logging in, we will help
            you set up your work week and favorites list
          </p>
          <p>Click here to begin.</p>
        </div>
      );
    }

    return (
      <Loader
        show={this.state.loading}
        {...loaderSettings}
        message="saving..."
      >
        <div className="loginScreen text-center">
          <a onClick={this.beginIntro}>
            {prompt}
          </a>
        </div>
        <Modal
          ariaHideApp={false}
          isOpen={this.state.isEditFavoritesOpen}
          onRequestClose={noop}
          style={MODAL_SETTINGS}
        >
          <FavoritesModal
            className="onBoardFavorites"
            nextStep={this.nextStepFavorites}
          />
        </Modal>
        <Modal
          ariaHideApp={false}
          isOpen={this.state.isWorkingHoursOpen}
          onRequestClose={noop}
          style={MODAL_SETTINGS}
        >
          <WorkingHoursModal
            nextStep={this.nextStepWorkingHours}
          />
        </Modal>
      </Loader>
    );
  }
}

function mapStateToProps (state, ownProps) {
  return {
    api: state.api,
    settings: state.settings
  };
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    setFirstTimeOff: () => dispatch({
      type: "SET_FIRST_TIME_LOGIN",
      firstTime: false
    }),
    updateUser: () => dispatch(getUser())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Welcome));



// WEBPACK FOOTER //
// ./app/components/Welcome/Welcome.jsx